import React from "react";

const sections = [
  {
    title: "Our Mission",
    highlight: "We",
    text: "promote mental health and wellbeing for all Individuals, couples and groups by integrating methods that address the mind, body and spirit for personal growth and transformation."
  },
  {
    title: "Our Vision",
    highlight: "To",
    text: "have a psychologically and mentally healthy society."
  }
];

function OurMission() {
  return (
    <section className="pb-8 md:pb-12">
      <div className="max-w-[1280px] mx-auto px-4 2xl:px-0 flex flex-col lg:flex-row justify-center gap-8 md:gap-12">
        {sections.map((section, idx) => (
          <div key={idx} className="flex-1">
            {/* Header */}
            <div className="flex items-center mx-auto w-full">
              <div>
                <h2 className="text-[22px] md:text-[28px] font-semibold mb-2">
                  {section.title}
                </h2>
                <div className="border-b-4 border-green-600 w-[50px] md:w-[100px]" />
              </div>
            </div>
            {/* Content */}
            <div className="flex justify-between mx-auto max-sm:flex-col mt-4">
              <div className="w-full md:w-[65%]">
                <h3 className="text-[16px] md:text-[18px] font-normal leading-relaxed">
                  <strong className="text-[20px]">{section.highlight}</strong>{" "}
                  {section.text}
                </h3>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default OurMission;
